import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OptionsObject, SnackbarKey } from "notistack";

type SnackbarItem = {
  message: string;
  key: SnackbarKey;
  options?: OptionsObject;
};

type SnackbarState = {
  enqueued: SnackbarItem[];
};

const initialState: SnackbarState = { enqueued: [] };

const slice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    enqueueSnackbar: (
      state,
      { payload }: PayloadAction<{ message: string; options?: OptionsObject }>,
    ) => {
      const key = payload.options?.key || new Date().getTime() + Math.random();

      state.enqueued.push({
        key,
        message: payload.message,
        // @ts-ignore
        options: {
          ...payload.options,
          key,
        },
      });
    },
    remove: (state, { payload }: PayloadAction<{ key: SnackbarKey }>) => {
      state.enqueued = state.enqueued.filter(item => item.key !== payload.key);
    },
  },
});

export const { enqueueSnackbar, remove } = slice.actions;
export default slice.reducer;
